module.exports = __webpack_public_path__ + "static/media/half_green_waves@2x.77fc6513.png";